import React, { useState } from "react";
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Button,
  Typography,
  Box,
  LinearProgress,
} from "@mui/material";
import { Link } from "react-router-dom";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ListAltIcon from "@mui/icons-material/ListAlt";
import GroupIcon from "@mui/icons-material/Group";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import LaunchIcon from "@mui/icons-material/Launch";
import AlarmIcon from "@mui/icons-material/Alarm";
import axios from "axios";
import AuthService from "../../utils/AuthService";

function CourseLaunchBtn({ course }) {
  console.log(course);
  const [enrolling, setEnrolling] = useState(false);
  const [enrolled, setEnrolled] = useState(false);

  async function enrollUser() {
    try {
      setEnrolling(true);
      const response = await axios.put(
        `/api/course/${course.id}/enroll`,
        null,
        AuthService.getAuthHeader()
      );
      setEnrolling(false);
      if (response.status === 205) setEnrolled(true);
    } catch (err) {
      setEnrolling(false);
      console.error(err);
    }
  }

  if (course.enrolledOn && !course.enrollmentAccepted) {
    return (
      <Button variant="text" endIcon={<AlarmIcon />}>
        PENDING APPROVAL
      </Button>
    );
  }
  if (!course.enrolledOn) {
    return enrolled ? (
      <Button variant="contained" endIcon={<AlarmIcon />}>
        PENDING APPROVAL
      </Button>
    ) : enrolling ? (
      <Box>
        <Typography> Enrolling...</Typography>
        <LinearProgress />
      </Box>
    ) : (
      <Button
        variant="contained"
        onClick={enrollUser}
        endIcon={<ControlPointIcon />}
      >
        ENROLL
      </Button>
    );
  }
  return (
    <Link
      to={`/Modules/Course/${course.id}`}
      state={{ courseName: course.name }}
    >
      <Button variant="contained" endIcon={<LaunchIcon />}>
        OPEN
      </Button>
    </Link>
  );
}

export default function CourseCard({ courses }) {
  if (!courses) {
    return (
      <Box display="flex" justifyContent="center" p={2}>
        <Typography>Loading...</Typography>
        <LinearProgress />
      </Box>
    );
  }

  return courses.map((course) => (
    <Card
      key={course.id}
      sx={{
        maxWidth: 360,
        width: "100%",
        margin: "8px",
        boxShadow: "rgba(2, 2, 2, 0.19) 0px 4px 12px",
      }}
    >
      <CardHeader
        title={
          <Typography
            variant="h4"
            sx={{
              paddingLeft: 1,
              fontWeight: 500,
            }}
          >
            {course.name}
          </Typography>
        }
      />
      <CardActions>
        <Box sx={{ flexGrow: 1 }} />
        <CourseLaunchBtn course={course} />
      </CardActions>
      <Link to={`/course/${course.id}`}>
        <Box
          component="img"
          sx={{ height: 200, width: "100%" }}
          src={course.mediaUrl}
          alt={course.name}
        />
      </Link>
      <CardContent>
        <Typography variant="body1">{course.description}</Typography>
      </CardContent>
    </Card>
  ));
}
